<a class="{{ video.new ? 'type-new' : '' }}"
   (click)="OpenYoutube( video )">
  <div class="img-box">
    <div class="img"
         [style.background]="makeYoutubeUrl(video.youtubeId)">
    </div>
    <div class="label-list">
      <!-- HG-202: 지역 태그 숨김 (향후 재사용 가능)
      <div class="label-box type-{{ GetRegion2Css(video.area1) }}"
           *ngIf="video.area1">
        {{ GetRegion2Name(video.area1) }}</div>
      -->
      <div class="label-box type-{{ GetRegion2Css(video.area1) }}sub"
           *ngIf="video.area2">
        {{ video.area2 }}</div>
    </div>
  </div>
  <div class="txt-box">
    <span [innerHTML]="video.title | resize | keepHtml"></span>
    <button type="button"
            class="bookmark-btn {{ getBmCss(video) }}"
            (click)="ToggleBookmark($event, video)"></button>
  </div>
</a>
